<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query.orderType.name" placeholder="business.label.orderType" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query.role.name" placeholder="business.label.roleName" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.add" icon="vxe-icon-add" size="mini" status="primary" @click="add"/>
        <vxe-button content="button.save" icon="vxe-icon-save" size="mini" status="primary" @click="save"/>
      </template>
      <vxe-table
        ref="table"
        :data="data"
        :edit-config="{}"
        :edit-rules="editRules"
        :loading="loading"
        keep-source>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column :edit-render="orderTypeRender" field="orderType.name" title="business.label.orderType"/>
        <vxe-column :edit-render="{name:'VxeSelect',options:roles}" field="role.id" title="business.label.role"/>
        <vxe-column :edit-render="{name:'VxeNumberInput',autoSelect:true,props:{min:1}}" field="ordinal" title="business.label.ordinal"/>
        <vxe-column :edit-render="{name:'VxeSelect',options:flowTypes}" field="flowType" title="business.label.flowType"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <order-type-modal ref="orderTypeModal" @change="(values,row)=>onInputChange(row,'orderType',values[0])"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { deleteOne, findAll, saveAll } from '@/api/Api'
import { ENTERPRISE } from '@/store/mutation-types'
import { ApprovalConfig } from '@/api/dto/config/ApprovalConfig'
import { OrderType } from '@/api/dto/common/OrderType'
import OrderTypeModal from '@/views/modal/OrderTypeModal.vue'
import { getEnums, getOptions, onInputChange } from '@/utils/util'

export default {
  name: 'ApproveConfig',
  components: { OrderTypeModal },
  data() {
    return {
      enterprise: Vue.ls.get(ENTERPRISE),
      loading: false,
      data: [],
      query: new ApprovalConfig(),
      page: 1,
      size: 20,
      contentSize: 0,
      roles: [],
      flowTypes: [],
      editRules: {
        'orderType.name': [{ required: true, message: '订单类型不能为空' }],
        'role.name': [{ required: true, message: '角色不能为空' }],
        ordinal: [{ required: true, type: 'number', message: '顺序不能为空' }]
      },
      orderTypeRender: {
        name: 'VxeInput',
        events: {
          click: ({ row }) => this.$refs.orderTypeModal.open({ available: true }, row),
          clear: ({ row }) => this.onInputChange(row, 'orderType')
        }
      }
    }
  },
  created() {
    findAll('roleFactory', { available: true }).then(res => {
      if (res.success) {
        this.roles = getOptions(res.result)
      }
      return getEnums('FlowType')
    }).then(result => {
      this.flowTypes = result
    })
  },
  activated() {
    this.refresh()
  },
  methods: {
    onInputChange,
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('approvalConfigFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result.map(item => {
            return new ApprovalConfig(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = new ApprovalConfig()
      this.refresh()
    },
    openModal(modal, args, e) {
      this.$refs[modal].open(args, e)
    },
    changeOrderType(row, record) {
      row.orderType = new OrderType(record)
    },
    add() {
      this.data.push(new ApprovalConfig())
    },
    async save() {
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      let saveData = this.$refs.table.getUpdateRecords().concat(this.$refs.table.getInsertRecords())
      if (saveData.length > 0) {
        this.loading = true
        saveData = saveData.map(item => {
          item.enterprise = this.enterprise
          return item.toJSONObject()
        })
        saveAll('approvalConfigPersister', saveData).then(res => {
          if (res.success) {
            this.fetch()
            this.$message.success(this.$t('message.saveSuccess'))
          }
        }).finally(() => this.loading = false)
      } else {
        this.$message.warning('无数据可保存')
      }
    },
    remove(row) {
      if (row.id) {
        this.loading = true
        deleteOne('approvalConfigDeleter', { id: row.id }).then(res => {
          if (res.success) {
            this.fetch()
            this.$message.success(this.$t('message.deleteSuccess'))
          }
        }).finally(() => this.loading = false)
      } else {
        this.data.splice(this.data.indexOf(row), 1)
      }
    }
  }
}
</script>